import type { ToolPart } from "../../types";
import { labelForTool } from "./tool-labels";
import { useMcpToolTitle } from "./use-mcp-tool-title";

interface Props {
  part: ToolPart;
}

function dotClass(status: string): string {
  if (status === 'completed') return 'tool-dot-done';
  if (status === 'error') return 'tool-dot-error';
  return 'tool-dot-active';
}

export function DefaultToolCard({ part }: Props) {
  const isActive = part.state.status === 'running';
  const hasArgs = part.state.input && Object.keys(part.state.input).length > 0;
  const hasResult = !!part.state.output || !!part.state.error;
  const canExpand = hasArgs || hasResult;
  const mcpTitle = useMcpToolTitle(part.tool);
  const label = labelForTool(part.tool, part.state.input, mcpTitle);

  return (
    <div className={`tool-step tool-${part.state.status}`}>
      <div className="tool-step-rail">
        <div className={`tool-step-dot ${dotClass(part.state.status)}`} />
      </div>
      <div className="tool-step-body">
        {canExpand ? (
          <details>
            <summary className={`tool-step-label ${isActive ? 'tool-active' : ''}`}>
              {label}
            </summary>
            <div className="tool-step-content">
              {hasArgs && (
                <pre className="tool-command">{JSON.stringify(part.state.input, null, 2)}</pre>
              )}
              {part.state.error && <pre className="tool-error">{part.state.error}</pre>}
              {part.state.output && !part.state.error && (
                <pre className="tool-output">
                  {part.state.output.length > 2000 ? part.state.output.slice(0, 2000) + '\u2026' : part.state.output}
                </pre>
              )}
            </div>
          </details>
        ) : (
          <div className={`tool-step-label ${isActive ? 'tool-active' : ''}`}>{label}</div>
        )}
      </div>
    </div>
  );
}
